import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import useStateHandler from '@/hooks/useStateHandler';
import OrderCard from '@/shared-components/cards/components/OrderCard';
import OrderShippingCard from '@/shared-components/cards/components/OrderShippingCard';
import GalleryCoolerIcon from '@/shared-components/icons/components/new-icons/GalleryCoolerIcon';

import './styles/OrderInfo.css';

export default function OrderInfo({ fetchData, setOpenIssueDetails }) {
  const { state } = useStateHandler();

  return (
    <>
      <div className="order-info__header">
        {fetchData.order_status === "cancelled" ? (
          <span className="order-info__text canceled dots-on-overflow font-size-medium">
            Order canceled
          </span>
        ) : fetchData.order_issue ? (
          <span
            className="order-info__text theme dots-on-overflow element-non-selectable font-size-medium"
            onClick={() => setOpenIssueDetails(true)}
          >
            An issue has been reported
          </span>
        ) : state.user_session._id === fetchData.order_buyer._id ? (
          fetchData.order_limited_edition_data ? (
            <>
              <LimitedEditionIcon className="order-info__icon"/>
              <span className="order-info__text dots-on-overflow font-size-medium">
                Suarte
              </span>
            </>
          ) : (
            <>
              <GalleryCoolerIcon className="order-info__icon"/>
              <span className="order-info__text dots-on-overflow font-size-medium">
                {fetchData.order_seller.user_name}
              </span>
            </>
          )
        ) : (
          <span className="order-info__text dots-on-overflow font-size-medium">
            {fetchData.order_status === "pending" ? "Pending shipment" : fetchData.order_status === "sent" ? "On its way" : "Completed"}
          </span>
        )}
      </div>

      <div className="order-info__order-card">
        <OrderCard 
          orderData={fetchData} 
          onSeeIssue={() => setOpenIssueDetails(true)}
        />
      </div>

      <OrderShippingCard shippingData={fetchData.order_shipping_address}/>
    </>
  );
}
